import { Link } from "react-router-dom";

/**
 * BBK stamped monogram + Bulk Buy Kits wordmark.
 * variant: "dark" (default, on light bg) | "light" (on charcoal bg)
 * size:    "sm" (nav) | "lg" (auth gate)
 */
export default function BrandMark({ variant = "dark", size = "sm", asLink = true }) {
  const isLight = variant === "light";
  const fg = isLight ? "text-bone" : "text-charcoal";
  const border = isLight ? "border-bone" : "border-charcoal";

  // iter_142 — bumped `sm` back up. It had drifted small over many iterations
  // (text-base 16px). Now sits at text-xl / text-[19px] — visually distinct
  // from nav links without overpowering the horizontal Nav row.
  const boxCls =
    size === "lg"
      ? "text-2xl px-3 py-1 border-[2.5px]"
      : "text-xl px-2.5 py-1 border-2";

  const wordCls =
    size === "lg"
      ? "text-xl tracking-[0.18em]"
      : "text-[19px] tracking-[0.16em]";

  const content = (
    <span className={`inline-flex items-center gap-3 ${fg}`} data-testid="brandmark">
      <span
        className={`font-serif font-semibold tracking-[0.02em] ${boxCls} ${border} leading-none`}
        aria-hidden
      >
        BBK
      </span>
      <span className={`font-serif uppercase ${wordCls}`}>Bulk Buy Kits</span>
    </span>
  );

  return asLink ? <Link to="/shop" className="inline-flex" data-testid="brand-link">{content}</Link> : content;
}
